export default angular.module("mars.vet.dnareports.controllers.upgrademodal",[]).controller('UpgradeModalController',
        function($scope, $uibModalInstance, EntryIDService, EntryService, reportdata) {
	'ngInject';

	let upgradeUrl = "";

	let resultString = reportdata.resultString;

    EntryService.getEntry(EntryIDService.getEntryID('Upgrade')).then(function(response) {

        let fields = response.fields;

		$scope.close = function () {
			$modalInstance.dismiss('cancel');
		};
		let modalOptions = {
	        headerText: fields.upgradeText,
	        upgradeUrl: fields.upgradeUrl.replace("<sampleID>", resultString.sampleID),
	        ok: upgradeNow,
	        close: learnMore,
	        dismiss: dismiss
	    };
	    $scope.modalOptions = modalOptions;

	   upgradeUrl = modalOptions.upgradeUrl;

    }, function(error) {
        // promise rejected, could log the error with:
        // console.log('error', error);
    });

    let upgradeNow = function upgradeNow() {
    	window.open(upgradeUrl, '_blank');
    	$uibModalInstance.close();
	};
	let learnMore = function learnMore() {
    	// window.open(upgradeUrl, '_blank');
    	$uibModalInstance.close();
	}
	let dismiss = function dismiss() {
    	// window.open(upgradeUrl, '_blank');
    	$uibModalInstance.close();
	}
}).name;


// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/upgrademodal.controller.js